import { initialLocaleState } from './initialState';
import * as localeActionTypes from '../constants/index';
import defaultLocaleProvider from '../services/defaultLocaleProvider';

export default (state = initialLocaleState, action = {}) => {
  switch (action.type) {
    case localeActionTypes.CHANGE_LOCALE_LANGUAGE_SUCCESS:
      return { ...state, locale: action.locale };

    case localeActionTypes.LOGOUT:
      return { locale: defaultLocaleProvider(navigator) };

    default:
      return state;
  }
};
